'use client';

import * as React from 'react';
import classNames from 'classnames';
import './styles.scss';

export interface ILayoutSplitProps {
  children: React.ReactNode;
  layout?: 'default' | 'article' | 'profile' | 'filter' | 'certificates' | 'api' | 'report';
  className?: string;
}

const LayoutSplit: React.FunctionComponent<ILayoutSplitProps> = (props) => {
  return (
    <div
      className={classNames(
        'layout-split',
        {
          ['layout-default']: props.layout === 'default' || !props.layout,
          ['layout-article']: props.layout === 'article',
          ['layout-profile']: props.layout === 'profile',
          ['layout-filter']: props.layout === 'filter',
          ['layout-certificates']: props.layout === 'certificates',
          ['layout-api']: props.layout === 'api',
          ['layout-report']: props.layout === 'report',
        },
        props.className,
      )}
    >
      {props.children}
    </div>
  );
};

LayoutSplit.displayName = 'LayoutSplit';

export default LayoutSplit;
